import { render, staticRenderFns } from "./CreditProductParameters.vue?vue&type=template&id=6dcb626d&scoped=true"
import script from "./CreditProductParameters.vue?vue&type=script&lang=js"
export * from "./CreditProductParameters.vue?vue&type=script&lang=js"
import style0 from "./CreditProductParameters.vue?vue&type=style&index=0&id=6dcb626d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb626d",
  null
  
)

export default component.exports